module.exports = __webpack_public_path__ + "img/HXL.7388d722.png";